

export interface FilterOptions {
    field: string,
    operator: '$eq' | '$ne' | '$gt' | '$gte' | '$lt' | '$lte' | '$like' | '$ilike' | '$in' | '$not';
    value: any;
}

export interface QueryBuilderOptions {
    page?: number;
    limit?: number;
    search?: string;
    filters?: FilterOptions[];
    sortBy?: Array<{ field: string; order: 1 | -1 }>;
}

export const QueryBuilder = (options: QueryBuilderOptions): string => {
    const { page = 1, limit = 10, search = '', filters = [], sortBy = [] } = options;

    const params = new URLSearchParams();

    if (page) params.append('page', page.toString());
    if (limit) params.append('limit', limit.toString());

    if (search) params.append('search', search);

    for (const filter of filters) {
        const value = filter.value;
        params.append(`filter.${filter.field}`, `${filter.operator}:${value}`);
    }

    for (const sort of sortBy) {
        params.append('sort', `${sort.field}:${sort.order}`);
    }

    return params.toString();
}
